export const initialRegion = "en"

export const listRegion = [
    { name: 'English', value: 'en' },
    { name: 'Français', value: 'fr' },
    { name: 'العربية', value: 'ar' },
]

export enum RegionActions {
    UPDATE = "UPDATE"
}

export interface RegionAction {
    type: RegionActions,
    payload: string
}

export const regionReducer = (state: string, action: RegionAction) => {
    const { type, payload } = action
    switch(type) {
        case RegionActions.UPDATE:
            return payload;
        default:
            return state
    }
}
